import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
var containerStyles = css({
  display: 'inline-block',
  minWidth: '1px',
  padding: '2px 6px',
  borderRadius: '24px',
  fontSize: '12px',
  fontWeight: 'normal',
  lineHeight: 1,
  textAlign: 'center'
});

/**
 * __Container__
 *
 * This component retains the styling of a normal badge, but without formatting.
 * This means you can compose in whatever information you need to.
 *
 * - [Examples](https://atlassian.design/components/badge/badge-container/examples)
 * - [Code](https://atlassian.design/components/badge/badge-container/code)
 * - [Usage](https://atlassian.design/components/badge/badge-container/usage)
 */
function Container(_ref) {
  var backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      innerRef = _ref.innerRef,
      restProps = _objectWithoutProperties(_ref, ["backgroundColor", "textColor", "innerRef"]);

  return jsx("span", _extends({}, restProps, {
    ref: innerRef,
    css: containerStyles,
    style: {
      backgroundColor: backgroundColor,
      color: textColor
    }
  }));
}

export default Container;